import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider, addLocaleData } from 'react-intl';
import enLocaleData from 'react-intl/locale-data/en';
import frLocaleData from 'react-intl/locale-data/fr';
import { makeStyles } from '@material-ui/styles';
import { CircularProgress } from '@material-ui/core';
import * as localesModels from '../../locales.model';
import { getMessagesFromConfig, getLocale } from './LocalesProvider.helper';
import styles from './LocalesProvider.styles';

const useStyles = makeStyles(styles);

// TODO: addLocaleData has been removed since 3.0.0--beta6
// will fix it in next release
addLocaleData([...enLocaleData, ...frLocaleData]);

const LocalesProvider = ({
  defaultLocale,
  dynamicMessages,
  selectedLocale,
  selectLocale,
  localeMessages,
  supportedLanguages,
  forceLocale,
  children,
  loadingInitialLocale,
}) => {
  const classes = useStyles();
  if (!selectedLocale) {
    if (!loadingInitialLocale) {
      selectLocale(
        getLocale({ supportedLanguages, forceLocale, defaultLocale })
      );
    }
  }

  const extra =
    process.env.NODE_ENV === 'development' ? { onError: () => {} } : {};

  return (
    <IntlProvider
      locale={selectedLocale}
      messages={getMessagesFromConfig(
        { ...dynamicMessages, ...localeMessages },
        selectedLocale
      )}
      defaultLocale={defaultLocale}
      data-cmp="locales-provider"
      {...extra}
    >
      <div>
        {(!selectedLocale || loadingInitialLocale) && (
          <div className={classes.container}>
            <div className={classes.overlay}>
              <div className={classes.loader}>
                <CircularProgress />
              </div>
            </div>
          </div>
        )}
        {selectedLocale && !loadingInitialLocale && children}
      </div>
    </IntlProvider>
  );
};

LocalesProvider.propTypes = {
  defaultLocale: PropTypes.string.isRequired,
  dynamicMessages: PropTypes.object.isRequired,
  selectLocale: PropTypes.func.isRequired,
  supportedLanguages: PropTypes.arrayOf(PropTypes.string).isRequired,
  forceLocale: PropTypes.string,
  loadingInitialLocale: PropTypes.bool,
  localeMessages: PropTypes.object,
  selectedLocale: localesModels.SelectedLocaleModel,
};

export default LocalesProvider;
